<template>
  <a-layout class="album-config">
    <a-layout-sider :width="140" theme="light">
      <a-menu
          :selectedKeys="selectKey"
          :style="{minHeight: menuHeight+'px', height: '100%'}" mode="inline">
        <a-menu-item :key="item.name" v-for="item in menuConfig">
          <router-link :to="{name: item.name}">
            <a-icon :type="item.icon"/>
            <span>{{ item.text }}</span>
          </router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout-content style="padding: 0 20px; overflow: hidden;">
      <div style="font-size: 20px;">
        <a-icon :type="$route.meta.icon"/>
        <span style="margin-left: 10px;">{{ $route.meta.title }}</span>
      </div>
      <a-divider style="margin: 20px 0;"></a-divider>
      <div :style="{width:viewWidth+'px'}" style="float: left; min-width: 560px;">
        <router-view :user="user" :album="album" @saved="refresh" v-if="album.id"/>
      </div>
      <div style="float:right;" v-if="viewWidth > 560">
        <a-space :size="25" direction="vertical">
          <div class="album-preview" id="previewFrame"></div>
          <a-row>
            <a-col span="16">
              <a-popover v-if="album.material">
                <template slot="content">
                  <div class="album-qr-code">
                    <ResourceImg :id="album.material.qr_code" width="100%"/>
                  </div>
                </template>
                <a-button block icon="scan">通过手机扫码预览</a-button>
              </a-popover>
            </a-col>
            <a-col span="8" style="text-align:right;">
              <a-button icon="reload" @click="refresh">刷新</a-button>
            </a-col>
          </a-row>
        </a-space>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import api from "../../../utils/api";
import func from "../../../utils/func";
import layout from "../../../store/layout";
import cache from "../../../utils/cache";
import ResourceImg from "../../../comps/ResourceImg";

export default {
  name: "Config",
  components: {ResourceImg},
  data() {
    return {
      user: {},
      album: {},
      menuConfig: []
    }
  },
  computed: {
    selectKey() {
      return layout.state.selectKey;
    },
    viewWidth() {
      return this.$store.getters["layout/contentWidth"] - 580;
    },
    menuHeight() {
      return this.$store.getters["layout/contentHeight"] - 60;
    },
    previewURL() {
      return api.v1.album.preview(this.album.id) + '?preview=1';
    }
  },
  created() {
    require("../../../router/album/config").default
        .forEach((route) => {
          func.hasMetaTitle(route) &&
          this.menuConfig.push({
            name: route.name,
            text: route.meta.title,
            icon: route.meta.icon,
          });
        });
  },
  mounted() {
    const self = this;
    api.v1.user.detail()
        .then(res => {
          self.user = res;
          cache.v1.album.detail(self.$route.params.id)
              .then(res => {
                self.album = res;
                self.refresh();
              });
        });
  },
  methods: {
    refresh() {
      let frame = document.getElementById("previewFrame");
      if (frame) frame.innerHTML = `<iframe src="${this.previewURL}" width="100%" height="100%" style="border: none;"></iframe>`;
    }
  }
}
</script>

<style lang="less" scoped>
.album-config {
  margin: 15px;
  padding: 15px 0;
  background: #fff;
}

.album-preview {
  width: 360px;
  height: 560px;
  background: #f1f1f1;
  box-shadow: 0 0 5px 1px #bbb;
}

.album-qr-code {
  width: 200px;
  height: 200px;
  padding: 15px;
  margin: -12px -16px;
  border-radius: 15px;
  background: #f1f1f1;
  box-shadow: 0 0 5px 1px #bbb;
}
</style>
